import { render, staticRenderFns } from "./Favourite.vue?vue&type=template&id=50b3c7ae"
import script from "./Favourite.vue?vue&type=script&lang=js"
export * from "./Favourite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b3c7ae')) {
      api.createRecord('50b3c7ae', component.options)
    } else {
      api.reload('50b3c7ae', component.options)
    }
    module.hot.accept("./Favourite.vue?vue&type=template&id=50b3c7ae", function () {
      api.rerender('50b3c7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Favourite.vue"
export default component.exports